/**
 * 数据源 / 物理表字段元数据类型（权威定义文件）。
 *
 * @canonical 5.3-2.2.1
 * @归属 dataSource 域（数据管理、SqlView、表编辑、拖拉拽表预览）
 * @来源 自 `types/databaseTable.ts` 与 `types/common/fieldType.ts` 归位；旧路径阶段三人工删除。
 * @对外入口 `import { DimensionType, FieldType, ... } from '@dbl/core/dataSource'`
 * @字段类型 `FieldType` 由 dataSource 域定义，经 `@dbl/core/dataSource` 对外导出。
 *
 * 表字段 wire 类型见 `@dbl/services/dataSource` · `ITableColumnDto` / `ITableColumnUpdateDto`。
 */

/** 列逻辑类型：数据源字段元数据与建图字段共同使用的合法取值集合。 */
export const FieldType = {
  Date: 'date',
  Time: 'time',
  String: 'string',
  Number: 'number',
  Float: 'float',
  Percent: 'percent',
  BigInt: 'bigint',
  Decimal: 'decimal',
} as const;

export type TFieldType = (typeof FieldType)[keyof typeof FieldType];

/** 维度/指标属性：公共维度、普通维度、指标、敏感字段。 */
export const DimensionType = {
  Common: 0,
  Normal: 1,
  Metric: 2,
  Sensitive: 3,
} as const;

export type TDimensionType =
  (typeof DimensionType)[keyof typeof DimensionType];

  /** 是否包含 255 特殊值（表字段编辑契约）。 */
export const Include255 = {
  Include: 0,
  Exclude: 1,
} as const;

export type TInclude255 = (typeof Include255)[keyof typeof Include255];

/** 维度值来源：原值 / 系统匹配 / 自定义。 */
export const DimensionValue = {
  Origin: 'origin',
  System: 'system',
  Customize: 'customize',
} as const;

export type TDimensionValue =
  (typeof DimensionValue)[keyof typeof DimensionValue];
